import { fetchAPI } from '@/lib/api'
import { getErrorMsg, t } from '@/lib/helpers'
import { useToast } from '@chakra-ui/react'
import { useMutation, useQueryClient } from 'react-query'
import { HOLIDAYS } from '../constants'

const deleteHoliday = async (id: number) => {
  await fetchAPI({
    path: `/holidays/${id}`,
    method: 'delete',
  })
}

export const useDeleteHoliday = () => {
  const toast = useToast()
  const queryClient = useQueryClient()

  return useMutation(deleteHoliday, {
    async onSuccess() {
      await queryClient.refetchQueries([HOLIDAYS])

      toast({
        description: t('views.admin.holidays.services.delete_success'),
        status: 'success',
        position: 'top-right',
        isClosable: true,
      })
    },
    onError(error) {
      toast({
        description: getErrorMsg(error),
        status: 'error',
        position: 'top-right',
        variant: 'left-accent',
        isClosable: true,
      })
    },
  })
}
